import { FormControl, GridLegacy as Grid } from '@mui/material'

export type TextFieldWrapperProps = {
    fullWidth?: boolean
    xs?: number
    required?: boolean
    label?: string
    hideLabel?: boolean
    styles?: React.CSSProperties
}

export default function TextFieldWrapper({
    fullWidth = false,
    xs = 6,
    children,
    label,
    required = false,
    hideLabel = false,
    styles,
}: React.PropsWithChildren<TextFieldWrapperProps>) {
    const showRequiredIndicator = !!(!hideLabel && required && label)

    return (
        <Grid item xs={fullWidth ? 12 : xs} style={styles}>
            <FormControl fullWidth required={showRequiredIndicator}>
                {children}
            </FormControl>
        </Grid>
    )
}
